import { gql, useMutation } from '@apollo/client';

import { GET_DOCUMENTS_BY_IDS } from 'src/hooks/documents/get-documents-by-ids.hook';

import { GET_EMPLOYEE_DOCUMENTS } from './get-employee-documents.hook';
import { GET_EMPLOYEE_BY_ID } from './get-employee-by-id.hook';

export const UPSERT_EMPLOYEE_DOCUMENT = gql`
  mutation upsertMemberDocument($payload: UpsertMemberDocumentInput!) {
    upsertMemberDocument(payload: $payload) {
      _id
    }
  }
`;

export const useUpsertEmployeeDocument = ({ onSuccess }: { onSuccess?: () => void }) => {
  const [upsertEmployeeDocument] = useMutation(UPSERT_EMPLOYEE_DOCUMENT, {
    refetchQueries: [GET_EMPLOYEE_DOCUMENTS, GET_EMPLOYEE_BY_ID, GET_DOCUMENTS_BY_IDS],
    onCompleted: onSuccess,
  });

  return upsertEmployeeDocument;
};
